<template>
  <v-layout row>
      <v-card>
        <v-toolbar color="secondary" dark class="chat">
          <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->

          <v-toolbar-title>Notifications</v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- <v-btn icon>
            <v-icon>search</v-icon>
          </v-btn> -->
        </v-toolbar>

        <v-list two-line>
          <template v-for="notification in sortedNotifications">
            <!-- <v-subheader
              v-if="item.header"
              :key="item.header"
            >
              {{ item.header }}
            </v-subheader>

            <v-divider
              v-else-if="item.divider"
              :inset="item.inset"
              :key="index"
            ></v-divider> -->

            <v-list-tile
              :key="notification.id"
              @click=""
            >
              <!-- <v-list-tile-avatar>
                <img :src="item.avatar">
              </v-list-tile-avatar> -->

              <v-list-tile-content>
                <v-list-tile-title v-html="(notification.read) ? notification.message : notification.message.bold()"></v-list-tile-title>
                <v-list-tile-sub-title v-html="(notification.read) ? new Date(notification.timestamp).toLocaleString() + ' - Seen': new Date(notification.timestamp).toLocaleString()"></v-list-tile-sub-title>
                <v-card-actions>
                    <v-btn v-if="notification.type=='ContactRequest'" flat color='primary' @click='respond(notification, true)'>Accept</v-btn>
                    <v-btn v-if="notification.type=='ContactRequest'" flat color='primary' @click='respond(notification, false)'>Reject</v-btn>
                </v-card-actions>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
      </v-card>
  </v-layout>
</template>

<script>
// import firebase from '../../Firebase/FirebaseInit'
export default {
  props: {
    notifications: Array
  },
  computed: {
    sortedNotifications () {
      return this.notifications.sort((a, b) => b.timestamp - a.timestamp)
    }
  },
  methods: {
    readMessages () {
      for (var i = 0; i < this.notifications.length; i++) {
        if (!this.notifications[i].read) {
          console.log(this.notifications[i])
          this.notifications[i].read = true
          this.$store.dispatch('readNotification', {user: this.$store.getters.user.id, notification: this.notifications[i].id})
        }
      }
    },
    respond (notification, accepted) {
      let timestamp = new Date().getTime()

      var message = this.$store.getters.user.name + ' has accepted your follow request!'
      if (!accepted) {
        message = this.$store.getters.user.name + ' has rejected your follow request!'
      }

      const response = {
        message,
        senderID: this.$store.getters.user.id,
        senderName: this.$store.getters.user.name,
        receiverID: notification.senderID,
        receiverName: notification.senderName,
        read: false,
        accepted,
        type: 'ContactResponse',
        timestamp
      }

      const sender = {
        contactID: notification.senderID,
        contactName: notification.senderName,
        accepted: true,
        timestamp
      }

      const receiver = {
        contactID: notification.receiverID,
        contactName: notification.receiverName,
        accepted: true,
        timestamp
      }

      if (accepted) {
        this.$store.dispatch('addContact', {payload: sender, userID: notification.receiverID})
        this.$store.dispatch('addContact', {payload: receiver, userID: notification.senderID})
      } else {
        this.$store.dispatch('deleteContact', {account: notification.senderID, contact: notification.receiverID})
      }

      this.$store.dispatch('sendNotification', response)

      notification.message = 'You have a new contact: ' + notification.senderName
      notification.accepted = true
      notification.read = true
      notification.timestamp = new Date().getTime()
      notification.type = 'ContactSuccess'

      this.$store.dispatch('updateNotification', notification)
    }
  },
  created () {
    console.log(this.$parent)
  }
}
</script>




// WEBPACK FOOTER //
// Messages.vue?0056a1c6